import Markdown from 'markdown-to-jsx';
import type { FC } from 'react';
import { ImageWithPlaceholder } from '@/app/components/shared/ImageWithPlaceholder';
import { getAspectRatio } from '@/app/utils';
import type { TemplateExampleImageResource } from '../types';

interface TemplateDescriptionProps {
  exampleImage: TemplateExampleImageResource | null;
  templateDescription: string;
}

export const TemplateDescription: FC<TemplateDescriptionProps> = ({ exampleImage, templateDescription }) => {
  return (
    <>
      {exampleImage && (
        <ImageWithPlaceholder
          className="h-[64px]"
          style={{
            aspectRatio: getAspectRatio({ size: exampleImage.size }),
          }}
          placeHolderClassName="rounded-8"
          src={exampleImage.uri}
          alt=""
        />
      )}
      {templateDescription && (
        <Markdown className="text-sm text-system-white [--title-font-size:14px] sm:[--title-font-size:12px]">
          {templateDescription}
        </Markdown>
      )}
    </>
  );
};
